module.exports = __webpack_public_path__ + "static/media/laundry1.48747ae3.svg";